import axios from "axios";

const instance = axios.create({
  //baseURL: 'https://red-taxi.com/api/',
  baseURL : 'https://redtaxi24.com/api/'
});

export default instance;